module.exports = __webpack_public_path__ + "static/media/colors.9ebb9ba4.jpg";